<template>
  <v-col cols="auto">
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600"
      persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Abrir lançamento
        </v-btn>
      </template>
      <template>
        <v-form
          @submit.prevent="save"
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-card>
            <v-toolbar color="primary" tile elevation="0" dark>{{
              titulo
            }}</v-toolbar>

            <v-card-text>
              <v-row>
                <v-col cols="12" class="mb-n7">
                  <v-select
                    @change="onChange"
                    class="text-center"
                    :items="meses"
                    item-text="itemText"
                    label="Mês de Lançamento"
                    :rules="[(v) => !!v || 'Mês de Lançamento é obrigatório.']"
                    filled
                    return-object
                  ></v-select>
                </v-col>

                <v-col cols="12" class="mb-n1">
                  <v-autocomplete
                    v-model="formulario.lancadoPor.id"
                    :items="lancadores()"
                    item-text="usuario.nome"
                    item-value="usuario.id"
                    label="Responsável"
                    filled
                    auto-select-first
                    :rules="[(v) => !!v || 'Responsável é obrigatório.']"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.usuario.nome }}
                      <v-spacer></v-spacer>
                      <v-chip>Organização: {{ data.item.usuario.organizacao.nome }}</v-chip>
                      <v-spacer></v-spacer>
                      <v-chip>Estado: {{ data.item.usuario.estado }}</v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.usuario.nome"></v-list-item-title>
                        <v-list-item-subtitle>Organização: {{ item.usuario.organizacao.nome }}</v-list-item-subtitle>
                        <v-list-item-subtitle>Estado: {{ item.usuario.estado }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" class="mt-n7 mb-n9">
                  <p class="ml-1">Previsão de Lançamento</p>
                </v-col>
                
                <v-col cols="6" class="mb-n6">
                  <v-select
                    @change="onChangeInicioLancamento"
                    class="text-center"
                    :items="meses"
                    item-text="itemText"
                    label="Início"
                    :rules="[(v) => !!v || 'Início do Lançamento é obrigatório.']"
                    filled
                    return-object
                  ></v-select>
                </v-col>
                <v-col cols="6" class="mb-n6">
                  <v-select
                    @change="onChangeConclusaoLancamento"
                    class="text-center"
                    :items="meses"
                    item-text="itemText"
                    label="Conclusão"
                    :rules="[(v) => !!v || 'Conclusão do Lançamento é obrigatório.']"
                    filled
                    return-object
                  ></v-select>
                </v-col>


              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end">
              <v-btn color="secondary" @click.prevent="fecharELimpar">Cancelar</v-btn>
              <v-btn :loading="isFetching" color="primary" type="submit"> Salvar </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from 'moment'
moment.locale('pt')

export default {
  props: {
    titulo: {
      require: true,
    },
    indicador: {
      require: true,
    },

  },
  computed: {
    ...mapState('lancamento', {
      isFetching: state => state.isFetching,
    }),    

    meses() {
      let meses = this.$store.getters["projeto/getMeses"](parseInt(this.$route.params.projetoId));
      let mesesFormatado = []

      meses.forEach((mes, indice) => {
        let data = moment(mes);
        let mesFormatado = {
          numeroMes: indice + 1,
          descricao: data.format("MMM.YYYY").toUpperCase(),
          itemText: ''
        }
        mesFormatado.itemText = mesFormatado.numeroMes + "ª " + mesFormatado.descricao

        mesesFormatado.push(mesFormatado);
      });

      return mesesFormatado;
    }
  },
  data() {
    return {
      valid: true,
      dialog: false,
      formulario: { lancadoPor: { id: null }},
    };
  },
  methods: {
    ...mapActions("lancamento", ["criarLancamento"]),

    lancadores() {
      var payload = {
        'papel': 'AGENTE_LANCAMENTO_FONTES',
        'projetoId': parseInt(this.$route.params.projetoId),
      }

      return this.$store.getters["projeto/getParticipantesByPapel"](payload);
    },

    participantes() {

      var payload = {
        'papel': 'AGENTE_MONITORAMENTO_PROGRAMATICO',
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.$store.getters["usuario/getUsuarioAutenticado"].id,
      }

      if(this.$store.getters["projeto/hasPapel"](payload)) {
        payload.papel = 'AGENTE_LANCAMENTO_FONTES'
        return this.$store.getters["projeto/getParticipantesByPapel"](payload);
      }
      let array = [];
      const participanteAtual = this.$store.getters["projeto/participanteAtual"](payload);
      this.formulario.lancadoPor.id = participanteAtual.usuario.id
      array.push(participanteAtual);
      return array
    },


    save() {
      if (this.$refs.form.validate()) {
        this.create()
          .then((lancamento) => {
            this.$refs.form.resetValidation();
            this.$emit("save", { lancamento });
            this.fecharELimpar();
          })
          .catch((error) => {
            if (error.response) {
              this.errorMessage = error.response.data;
            }
          });
      }
    },
    create() {
      const payload = {
        indicadorId: parseInt(this.indicador.id),
        lancamento: this.formulario,
      };

      return this.criarLancamento(payload);
    },
    fecharELimpar() {
      this.$refs.form.reset();
      this.formulario = { lancadoPor: { id: null }}
      this.dialog = false;
    },

    onChange(value) {
      this.formulario["mes"] = value.numeroMes;
      this.formulario["descricao"] = value.descricao;
    },

    onChangeInicioLancamento (value) {
      this.formulario["mesInicioLancamento"] = value.numeroMes;
      this.formulario["descricaoInicioLancamento"] = value.descricao;
    },

    onChangeConclusaoLancamento(value) {
      this.formulario["mesConclusaoLancamento"] = value.numeroMes;
      this.formulario["descricaoConclusaoLancamento"] = value.descricao;
    }
  },
};
</script>
